import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Signup from './components/Signup/signup';
import Signin from './components/Signin/signin';
import {AuthenticatedPage, AuthenticatePage, AuthenticatPage} from './components/AuthenticatedPage/Authenticatedpage';  

const App = () => {
  const [user, setUser] = useState(null);
  const [showSigninModal, setShowSigninModal] = useState(false);
  const [selectedProducts] = useState([]);

  const handleSignup = (username, password) => {
    // Get users list from local storage
    const usersListString = localStorage.getItem('usersList');
    let usersList = [];
  
    try {
      if (usersListString) {
        usersList = JSON.parse(usersListString);
      }
    } catch (error) {
      // Handle the JSON parsing error, e.g., show an error message or log the error
      console.error('Error parsing usersList:', error);
    }
  
    if (usersList.find(currUser => currUser.username === username)) {
      alert('Username already exists!');
    } else {
      usersList.push({ username, password });
      // Store updated usersList as a JSON string in local storage
      localStorage.setItem('usersList', JSON.stringify(usersList));
  
      setUser(username);
      localStorage.setItem('username', username);
    }
  };
  

  const handleSignin = (username, password) => {
    // Check if username and password match the stored values
    const usersListString = localStorage.getItem('usersList');
    if (usersListString) {
      const usersList = JSON.parse(usersListString);
      const storedUser = usersList.find(currUser => currUser.username === username);
  
      if (storedUser && password === storedUser.password) {
        setUser(username);
        setShowSigninModal(false);
      } else {
        alert('Invalid username or password');
      }
    } else {
      alert('No users found. Please sign up first.');
    }
  };
  

  const handleLogout = () => {
    // Clear the stored username and password
    // localStorage.removeItem('password');
    
    localStorage.removeItem('username');
    setUser(null);
  };

  const handleCloseSigninModal = () => {
    setShowSigninModal(false);
  };

  const handleShowSigninModal = () => {
    setShowSigninModal(true);
  };

  const renderAuthenticatedContent = () => {
    return (
      <div>
        <button onClick={handleLogout} className="btn btn-primary">Sign out</button>
        <Navigate to="/foodlist" replace />        
      </div>
    );
  };

  const renderUnauthenticatedContent = () => {
    return (
      <div>
        <Signup onSignup={handleSignup} handleSigninModal={handleShowSigninModal} />
        <hr />
        
      </div>
    );
  };

  return (
    <Router>
      <div className="container">
       
        <Routes>
          <Route path="/" element={user ? renderAuthenticatedContent() : renderUnauthenticatedContent()} />
          <Route path="/foodlist" element={<AuthenticatedPage handleLogout={handleLogout} />} />
          <Route path="/reminder" element={<AuthenticatePage handleLogout={handleLogout} />} />  
          <Route path="/shoplist" element={<AuthenticatPage handleLogout={handleLogout} selectedProducts={selectedProducts} />} />       
        </Routes>

        <Modal show={showSigninModal} onHide={handleCloseSigninModal}>
          <Modal.Header closeButton>
            <Modal.Title>Signin</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Signin onSignin={handleSignin} />
          </Modal.Body>
        </Modal>
      </div>
    </Router>
  );
};

export default App;
